/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/**
 * Podobne losowania — kontroler strony.
 *
 * Zbiera zestaw z formularza, wczytuje pelna historie gry (roczniki + recent),
 * przycina ja do wybranego zakresu i oddaje modelowi PEWNIAKI_PODOBNE.
 * Liczeniem i rysowaniem tabeli zajmuje sie model; tutaj zostaje walidacja,
 * siec i kolejnosc odpowiedzi.
 */
(function () {
    'use strict';

    function enText(pl, en) { return typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? en : pl; }

    var root = document.querySelector('[data-f6-podobne]');
    if (!root || !window.PEWNIAKI_PODOBNE) {
        return;
    }

    var gra = root.getAttribute('data-gra') || '';
    var pula = parseInt(root.getAttribute('data-pula'), 10) || 0;
    var typuje = parseInt(root.getAttribute('data-typuje'), 10) || 0;
    var specPula = parseInt(root.getAttribute('data-special-pula'), 10) || 0;
    var specTypuje = parseInt(root.getAttribute('data-special-typuje'), 10) || 0;
    var wzorDnia = root.getAttribute('data-url-dnia') || '';

    var form = root.querySelector('[data-f6-form]');
    var poleMain = root.querySelector('[data-f6-main]');
    var poleSpec = root.querySelector('[data-f6-special]');
    var elBlad = root.querySelector('[data-f6-error]');
    var selOkno = root.querySelector('[data-zakres-okno]');
    var wyniki = root.querySelector('[data-pp-root]');
    var elKule = root.querySelector('[data-f6-kule]');
    var klasaKuli = (root.querySelector('[data-f6-klasa-kuli]') || {}).getAttribute
        ? root.querySelector('[data-f6-klasa-kuli]').getAttribute('data-f6-klasa-kuli')
        : 'kula';

    var zadanie = 0;      // numer biezacego zadania — starsza odpowiedz przepada
    var historia = null;  // wczytana raz na strone

    /* ---------- pomoce ---------- */

    function pokazBlad(tekst) {
        if (!elBlad) {
            return;
        }
        elBlad.textContent = tekst || '';
        if (tekst) {
            elBlad.removeAttribute('hidden');
        } else {
            elBlad.setAttribute('hidden', '');
        }
    }

    function wyczyscWyniki() {
        // Wnioski sa czescia wyniku; nie zostawiaj poprzedniego zestawu
        // podczas pobierania ani po bledzie formularza lub sieci.
        var wnioski = wyniki.querySelector('[data-analiza-wnioski] .wniosek__lista');
        if (wnioski) {
            wnioski.replaceChildren();
        }
        var tbody = wyniki.querySelector('[data-pp-body]');
        while (tbody && tbody.firstChild) {
            tbody.removeChild(tbody.firstChild);
        }
        var n = wyniki.querySelector('[data-pp-value="N"]');
        if (n) {
            n.textContent = '0';
        }
        if (elKule) {
            while (elKule.firstChild) {
                elKule.removeChild(elKule.firstChild);
            }
            elKule.setAttribute('hidden', '');
        }
        var linkNastepne = root.querySelector('[data-podobne-nastepne]');
        if (linkNastepne) linkNastepne.setAttribute('hidden', '');
    }

    /** Lista pelnych liczb calkowitych z pola tekstowego; null = zapis niepoprawny. */
    function liczbyZPola(tekst) {
        var czesci = String(tekst || '').split(/[\s,;]+/).filter(function (c) { return c !== ''; });
        var out = [];
        for (var i = 0; i < czesci.length; i++) {
            if (!/^\d+$/.test(czesci[i])) {
                return null;
            }
            out.push(parseInt(czesci[i], 10));
        }
        return out;
    }

    function sprawdzZestaw(liczby, ile, max, nazwa) {
        if (liczby === null) {
            return jst("pages_podobne_strona_js.37c4c8218a4d") + nazwa + ').';
        }
        if (liczby.length !== ile) {
            return jst("pages_podobne_strona_js.07247a8749a5") + ile + jst("pages_podobne_strona_js.5fb80cab9d15") + nazwa + jst("pages_podobne_strona_js.c1d91c8efd6d") + liczby.length + '.';
        }
        var widziane = {};
        for (var i = 0; i < liczby.length; i++) {
            var n = liczby[i];
            if (n < 1 || n > max) {
                return jst("pages_podobne_strona_js.d141895bf4a8") + n + jst("pages_podobne_strona_js.215752233d5a") + max + ' (' + nazwa + ').';
            }
            if (widziane[n]) {
                return jst("pages_podobne_strona_js.d141895bf4a8") + n + jst("pages_podobne_strona_js.53cc47fba14b") + nazwa + ').';
            }
            widziane[n] = true;
        }
        return null;
    }

    function dataGodzina(iso) {
        var m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(String(iso || ''));
        if (!m) {
            return String(iso || '');
        }
        return m[3] + '.' + m[2] + '.' + m[1] + ' ' + m[4] + ':' + m[5];
    }

    function json(url) {
        return fetch(url, { credentials: 'same-origin' }).then(function (o) {
            if (!o.ok) {
                throw new Error(jst("pages_podobne_strona_js.44febb42378b") + url + ').');
            }
            return o.json().catch(function () {
                throw new Error(jst("pages_podobne_strona_js.e3122aa857e9") + url + ').');
            });
        });
    }

    /* ---------- historia gry ---------- */

    function klucz(l) {
        return String(l.drawn_at || '') + '|' + ((l.draw_system_id ?? l.legacy_id) === null || (l.draw_system_id ?? l.legacy_id) === undefined ? '' : (l.draw_system_id ?? l.legacy_id));
    }

    function dodaj(mapa, draws, url) {
        if (!Array.isArray(draws)) {
            throw new Error(jst("pages_podobne_strona_js.e3122aa857e9") + url + ').');
        }
        for (var i = 0; i < draws.length; i++) {
            var l = draws[i];
            if (!l || typeof l !== 'object' || !l.drawn_at || !Array.isArray(l.numbers)) {
                throw new Error(jst("pages_podobne_strona_js.e3122aa857e9") + url + ').');
            }
            mapa[klucz(l)] = l;
        }
    }

    function wczytajHistorie() {
        if (historia) {
            return Promise.resolve(historia);
        }
        var baza = '/assets/json/db/' + gra + '/';
        return json(baza + 'heatmap.json').then(function (h) {
            var lata = Object.keys((h && h.lata) || {}).filter(function (r) { return /^\d{4}$/.test(r); });
            if (lata.length === 0) {
                throw new Error(jst("pages_podobne_strona_js.38cf0c33c32e"));
            }
            lata.sort();
            var mapa = {};
            var kolejka = Promise.resolve();
            lata.forEach(function (rok) {
                kolejka = kolejka.then(function () {
                    var url = baza + 'rok-' + rok + '.json';
                    return json(url).then(function (r) { dodaj(mapa, r && r.draws, url); });
                });
            });
            return kolejka.then(function () {
                var url = baza + 'recent.json';
                return json(url).then(function (r) { dodaj(mapa, r && r.draws, url); });
            }).then(function () {
                var lista = Object.keys(mapa).map(function (k) { return mapa[k]; });
                lista.sort(function (a, b) {
                    var ta = Date.parse(a.drawn_at) || 0;
                    var tb = Date.parse(b.drawn_at) || 0;
                    if (ta !== tb) {
                        return ta - tb;
                    }
                    return (parseInt((a.draw_system_id ?? a.legacy_id), 10) || 0) - (parseInt((b.draw_system_id ?? b.legacy_id), 10) || 0);
                });
                historia = lista;
                return lista;
            });
        });
    }

    /* ---------- kule zestawu ---------- */

    function pokazKule(main, spec) {
        if (!elKule) {
            return;
        }
        main.forEach(function (n) {
            var s = document.createElement('span');
            s.className = klasaKuli;
            s.setAttribute('role', 'listitem');
            s.setAttribute('aria-label', jst("pages_podobne_strona_js.f7d04c7f950a") + n);
            s.textContent = String(n);
            elKule.appendChild(s);
        });
        spec.forEach(function (n) {
            var s = document.createElement('span');
            s.className = 'kula kula--specjalna';
            s.setAttribute('role', 'listitem');
            s.setAttribute('aria-label', jst("pages_podobne_strona_js.0d434940417f") + n);
            s.textContent = String(n);
            elKule.appendChild(s);
        });
        elKule.removeAttribute('hidden');
    }

    /* ---------- uzupelnienie kolumny daty i numeru ---------- */

    function popraw(raport, lista) {
        if (!raport || raport.powod !== null) {
            return;
        }
        var uzyte = {};
        var wiersze = wyniki.querySelectorAll('[data-pp-row]');
        for (var i = 0; i < wiersze.length; i++) {
            var w = raport.wyniki[i];
            if (!w) {
                continue;
            }
            var zrodlo = null;
            for (var j = 0; j < lista.length; j++) {
                if (uzyte[j] || lista[j].drawn_at !== w.data) {
                    continue;
                }
                var id = lista[j].draw_system_id ?? lista[j].legacy_id;
                var pusty = (id === null || id === undefined || id === '');
                if ((pusty && w.numer === 0) || (!pusty && parseInt(id, 10) === w.numer)) {
                    zrodlo = lista[j];
                    uzyte[j] = true;
                    break;
                }
            }

            var kData = wiersze[i].querySelector('[data-pp-cell="data"]');
            var kNumer = wiersze[i].querySelector('[data-pp-cell="numer"]');
            if (kData) {
                while (kData.firstChild) { kData.removeChild(kData.firstChild); }
                var dzien = String(w.data || '').slice(0, 10);
                var napis = dataGodzina(w.data);
                if (wzorDnia && /^\d{4}-\d{2}-\d{2}$/.test(dzien)) {
                    var a = document.createElement('a');
                    a.href = wzorDnia.replace('__DATA__', dzien);
                    a.textContent = napis;
                    kData.appendChild(a);
                } else {
                    kData.textContent = napis;
                }
            }
            if (kNumer) {
                var idZrodla = zrodlo ? (zrodlo.draw_system_id ?? zrodlo.legacy_id) : null;
                kNumer.textContent = (idZrodla === null || idZrodla === undefined || idZrodla === '')
                    ? '—'
                    : String(idZrodla);
            }
        }
    }

    function aktualizujLinkNastepne(liczby, okno) {
        var link = root.querySelector('[data-podobne-nastepne]');
        if (!link || !root.getAttribute('data-url-nastepne')) return;
        var adres = new URL(root.getAttribute('data-url-nastepne'), window.location.href);
        adres.searchParams.set('liczby', liczby.join(','));
        adres.searchParams.set('warunek', 'wszystkie');
        adres.searchParams.set('okno', okno);
        link.href = adres.pathname + '?' + adres.searchParams.toString() + adres.hash;
        link.removeAttribute('hidden');
    }

    /* ---------- glowny przebieg ---------- */

    function uruchom() {
        var moje = ++zadanie;
        pokazBlad('');
        wyczyscWyniki();

        var main = liczbyZPola(poleMain ? poleMain.value : '');
        var komunikat = sprawdzZestaw(main, typuje, pula, jst("pages_podobne_strona_js.1ea4d7c01de1"));
        if (komunikat) {
            pokazBlad(komunikat);
            return;
        }

        var spec = [];
        if (specTypuje > 0) {
            spec = liczbyZPola(poleSpec ? poleSpec.value : '');
            var kSpec = sprawdzZestaw(spec, specTypuje, specPula, jst("pages_podobne_strona_js.242c33bbc79a"));
            if (kSpec) {
                pokazBlad(kSpec);
                return;
            }
        }

        var okno = selOkno ? selOkno.value : '25';
        var adres = new URL(window.location.href);
        adres.searchParams.set('liczby', main.join(','));
        adres.searchParams.set('okno', okno);
        if (spec.length) adres.searchParams.set('dodatkowe', spec.join(',')); else adres.searchParams.delete('dodatkowe');
        window.history.replaceState(null, '', adres.pathname + '?' + adres.searchParams.toString() + adres.hash);

        wczytajHistorie().then(function (lista) {
            if (moje !== zadanie) {
                return;
            }
            var wybrane = lista;
            if (okno !== 'all') {
                var n = parseInt(okno, 10);
                if (lista.length < n) {
                    pokazBlad(jst("pages_podobne_strona_js.70e73629bcb9") + lista.length
                        + jst("pages_podobne_strona_js.1ba5df28cc85") + n + jst("pages_podobne_strona_js.f024f4548ed3"));
                    return;
                }
                wybrane = lista.slice(lista.length - n);
            }
            if (wybrane.length === 0) {
                pokazBlad(jst("pages_podobne_strona_js.c15d5a7d84c8"));
                return;
            }

            window.setTimeout(function () {
                if (moje !== zadanie) return;
                var raport = window.PEWNIAKI_PODOBNE.render(wyniki, {
                    losowania: wybrane, zestaw: main, zestaw_special: spec,
                    pula: pula, typuje: typuje, special_pula: specPula, special_typuje: specTypuje
                });
                popraw(raport, wybrane); pokazKule(main, spec); aktualizujLinkNastepne(main, okno);
            }, 0);
        }).catch(function (e) {
            if (moje !== zadanie) {
                return;
            }
            wyczyscWyniki();
            pokazBlad(e && e.message ? e.message : jst("pages_podobne_strona_js.ccb751409c2f"));
        });
    }

    /* ---------- start ---------- */

    var params = new URLSearchParams(window.location.search);
    if (poleMain && params.get('liczby')) poleMain.value = params.get('liczby');
    if (poleSpec && params.get('dodatkowe')) poleSpec.value = params.get('dodatkowe');
    Array.prototype.forEach.call(root.querySelectorAll('[data-podobne-zrodlo]'), function (button) {
        button.addEventListener('click', function () {
            var source = button.getAttribute('data-podobne-zrodlo');
            if (source === 'saved') {
                try {
                    var store = JSON.parse(localStorage.getItem('pewniaki:moje-zestawy:v2') || '{}');
                    var sets = store && store.games && store.games[gra];
                    if (!Array.isArray(sets) || !sets.length) throw new Error(jst("pages_podobne_strona_js.8e9357ef1c5a"));
                    poleMain.value = (sets[0].numbers || []).join(' ');
                    if (poleSpec) poleSpec.value = (sets[0].extra || []).join(' ');
                    uruchom();
                } catch (e) { pokazBlad(e.message || jst("pages_podobne_strona_js.d84439205709")); }
            } else {
                wczytajHistorie().then(function (list) {
                    if (!list.length) throw new Error(jst("pages_podobne_strona_js.043c774b4651"));
                    var last = list[list.length - 1];
                    poleMain.value = (last.numbers || []).slice(0, typuje).join(' ');
                    if (poleSpec) poleSpec.value = (last.special || []).slice(0, specTypuje).join(' ');
                    uruchom();
                }).catch(function(e){ pokazBlad(e.message); });
            }
        });
    });

    if (selOkno) {
        var zUrl = new URLSearchParams(window.location.search).get('okno');
        if (zUrl) {
            for (var i = 0; i < selOkno.options.length; i++) {
                if (selOkno.options[i].value === zUrl) {
                    selOkno.value = zUrl;
                    break;
                }
            }
        }
        selOkno.addEventListener('change', uruchom);
    }

    if (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            uruchom();
        });
    }

    // Udostępniony adres ma od razu odtworzyć wynik, a nie tylko wypełnić pola.
    if (params.get('liczby')) {
        uruchom();
    }
})();
